(() => {
  const updateVariant = (input) => {
    const card = input.closest('product-card');
    if (!card) return;

    const price = card.querySelector('.warf-bs-price');
    const button = card.querySelector('.warf-bs-atc');
    const buttonText = button?.querySelector('.quick-add-btn-text');
    const productForm = input.closest('product-form');

    if (price && input.dataset.priceHtml) {
      price.innerHTML = input.dataset.priceHtml;
    }

    if (buttonText && input.dataset.price) {
      buttonText.textContent = `Add to cart · ${input.dataset.price}`;
    }

    if (productForm) {
      productForm.dataset.variantId = input.value;
    }
  };

  const initialize = (root = document) => {
    root
      .querySelectorAll('.warf-bs-variant-input:checked')
      .forEach(updateVariant);
  };

  document.addEventListener('change', (event) => {
    if (event.target.matches('.warf-bs-variant-input')) {
      updateVariant(event.target);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize());
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initialize(event.target);
  });
})();